export class Units {
    public static get UNIT(): number { return 1 };
    public static get GRAM(): number { return 2 };
    public static get LITER(): number { return 3 };
    public static get KG(): number { return 4 };
    public static get PERSON(): number { return 5 };
}